module.exports = __webpack_public_path__ + "img/14-r.48a7350d.png";